export default __webpack_public_path__ + "static/media/IMG_1982.56033b85.JPG";